<template>

  <div>
    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :blank-grupo-data="blankCategoryData"
      @refetch-data="refetchData"
      @input="showAddEditUsuario"
    />

    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
      @statusFilter="updatedStatusFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                  v-if="$can('create', 'Vendedor')"
                variant="primary"
                @click="addCategory"
              >

                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Categoria
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refCategoriaListTable"
        class="position-relative"
        :items="fetchCategories"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(name_category)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.name_category)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.name_category }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: data_inclusao -->
        <template #cell(data_inclusao)="data">
          <span class="text-nowrap">{{ data.item.data_inclusao | formatDateTimeBr }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>
        <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
                v-if="$can('read', 'Vendedor')"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-tooltip.hover.top="'Visualizar'"
                size="20"
                style="color: var(--secondary);"
                icon="EyeIcon"
                class="icon-activity"
                @click.stop="viewCategory(data.item.id)"
            />
            <feather-icon
                v-if="$can('update', 'Vendedor')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editCategory(data.item.id)"
            />
            <feather-icon
                v-if="$can('delete', 'Vendedor')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Deletar'"
              v-b-modal.modal-confirme-delete-grupo
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idCategory = data.item.id"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalCategories"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-grupo"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o grupo?"
      @ok="deleteCategory"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onMounted,
} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import useCategoryList from '@/views/apps/categorias/category-list/useCategoryList'
import UsersListFilters from './CategoryListFilters.vue'
import UserListAddNew from './CategoryListAddNew.vue'
import { formatDateTimeBr } from '@core/utils/filter'
import router from '@/router'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  filters: {
    formatDateTimeBr,
  },
  setup() {
    const toast = useToast()
    const blankCategoryData = ref({
      id: null,
      nome: '',
      descricao: '',
      ativo: 1,
    })
    const gruposOptions = ref([])
    onMounted(() => {
      store.dispatch('appAdmCategory/fetchCategories')
    })

    const updatedStatusFilter = () => {
      store.dispatch('appAdmCategory/fetchCategories')
    }

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addCategory = async () => {
      blankCategoryData.value = {
        id: null,
        nome: '',
        descricao: '',
        ativo: 1,
      }
      isAddNewUserSidebarActive.value = true
    }

    const editCategory = async categoriaId => {
      await store.dispatch('appAdmCategory/fetchCategory', { id: categoriaId })
        .then(data => {
          blankCategoryData.value = data.data
          isAddNewUserSidebarActive.value = true
        })
    }

    const viewCategory = id => {
      router.push({ name: 'app-admin-category-view', params: { id } })
    }

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const {
      fetchCategories,
      tableColumns,
      perPage,
      currentPage,
      totalCategories,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCategoriaListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
    } = useCategoryList()

    const idCategory = ref(null)
    const deleteCategory = async () => {
      await store.dispatch('appAdmCategory/deleteCategory', { id: idCategory.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idCategory.value = null
          refetchData()
        })
      refetchData()
    }
    return {
      idCategory,
      addCategory,
      blankCategoryData,
      editCategory,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      fetchCategories,
      tableColumns,
      perPage,
      currentPage,
      totalCategories,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCategoriaListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      updatedStatusFilter,
      deleteCategory,
      viewCategory,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
